<template>
    <div class="dd-m-auth dd-m-auth--register">
        <div class="dd-m-auth__content">
            <h2 class="dd-m-auth__title">Create an account</h2>

            <div class="dd-m-auth__form">
                <!-- Add class in dd-m-form__col when validate fields
                    has-error => error | is-validated => field filled successfully -->

                <form class="dd-m-form dd-m-form--login dd-m-form--auth"
                      novalidate v-on:submit.prevent="send">
                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col"
                             v-bind:class="{'has-error' : fields.email && !fields.email.valid && fields.email.touched
                              && !user.email.errors.length,
                             'is-validated' : fields.email && fields.email.valid && fields.email.touched && !user.email.errors.length}">
                            <input name="email"
                                   type="email"
                                   v-model="user.email.value"
                                   v-on:focus="user.email.errors = []"
                                   v-validate="'required|email'"
                                   required
                                   placeholder="E-mail"
                                   class="dd-m-form__input dd-m-form__input--bordered"/>

                            <div class="dd-m-form__error-msg" v-if="user.email.errors.length">
                                {{user.email.errors[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col"
                             v-bind:class="{'has-error' : fields.password && !fields.password.valid &&
                             fields.password.touched && !user.password.errors.length,
                             'is-validated' : fields.password && fields.password.valid && fields.password.touched &&
                             !user.password.errors.length}">
                            <input name="password"
                                   type="password"
                                   required
                                   v-model="user.password.value"
                                   v-validate="'required'"
                                   v-on:focus="user.password.errors = []"
                                   placeholder="Senha"
                                   class="dd-m-form__input dd-m-form__input--bordered"/>

                            <div class="dd-m-form__error-msg" v-if="user.password.errors.length">
                                {{user.password.errors[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col"
                             v-bind:class="{'has-error' : fields.confirm_password && !fields.confirm_password.valid
                             && fields.confirm_password.touched && !user.password_confirmation.errors.length,
                             'is-validated' : fields.confirm_password && fields.confirm_password.valid &&
                             fields.confirm_password.touched && !user.password_confirmation.errors.length}">
                            <input name="confirm_password"
                                   type="password"
                                   required
                                   v-model="user.password_confirmation.value"
                                   v-validate="{is: user.password.value, required: true}"
                                   v-on:focus="user.password_confirmation.errors = []"
                                   placeholder="Confirmar senha"
                                   class="dd-m-form__input dd-m-form__input--bordered"/>

                            <div class="dd-m-form__error-msg" v-if="user.password_confirmation.errors.length">
                                {{user.password_confirmation.errors[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col">
                            <vue-ladda
                                    button-class="dd-m-form__submit dd-m-button dd-m-button--default dd-m-button--assertive"
                                    :loading="loading">
                                Criar Conta
                            </vue-ladda>
                        </div>
                    </div>

                    <div class="dd-m-form--auth__actions">
                        <button v-on:click="openLoginModal()" type="button"
                                class="dd-m-form--auth__btn dd-m-form--auth__login-btn">
                            Já possui uma conta? Conecte-se
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import AuthService from '../../providers/api/auth-service';

    const api = new AuthService();

    export default {
        name: 'auth-register',
        data: () => {
            return {
                loading: false,
                user: {
                    email: {
                        value: null,
                        errors: []
                    },
                    password: {
                        value: null,
                        errors: []
                    },
                    password_confirmation: {
                        value: null,
                        errors: []
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            resetErrors() {
                for (const k in this.user) {
                    if (this.user.hasOwnProperty(k)) {
                        this.user[k].errors = [];
                    }
                }
            },
            openLoginModal: () => {
                PubSub.publish('closeRegisterModal');
                PubSub.publish('openLoginModal');
            },
            send() {
                this.resetErrors();
                this.loading = true;
                const user = {};

                for (const k in this.user) {
                    if (this.user.hasOwnProperty(k)) {
                        user[k] = this.user[k].value
                    }
                }

                api.doRegister(user)
                    .then((res) => {
                        this.loading = false;
                        api.doSaveToken(res.data.data.token);
                        PubSub.publish('updatedSign');

                        setTimeout(() => {
                            PubSub.publish('updateRegisterStep', {step: 2});
                        }, 100);
                    })
                    .catch((err) => {
                        this.loading = false;
                        if (err.response && err.response.status === 422) {
                            const errValidations = err.response.data.error.validations;
                            for (const j in errValidations) {
                                if (errValidations.hasOwnProperty(j) && this.user[j]) {
                                    this.user[j].errors = errValidations[j];
                                }
                            }
                        }
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/auth-register.vue